module.exports = __webpack_public_path__ + "img/toggle-01-left.d31dfb21.svg";